/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IllustrationsRouteRouteImport } from './routes/illustrations/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IllustrationsIndexRouteImport } from './routes/illustrations/index'
import { Route as VerifyTokenRouteImport } from './routes/verify.$token'
import { Route as IllustrationsIllustrationIdRouteRouteImport } from './routes/illustrations/$illustrationId/route'
import { Route as IllustrationsNewIndexRouteImport } from './routes/illustrations/new/index'
import { Route as IllustrationsIllustrationIdIndexRouteImport } from './routes/illustrations/$illustrationId/index'
import { Route as IllustrationsIllustrationIdEditRouteImport } from './routes/illustrations/$illustrationId/edit'

const IllustrationsRouteRoute = IllustrationsRouteRouteImport.update({
  id: '/illustrations',
  path: '/illustrations',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IllustrationsIndexRoute = IllustrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IllustrationsRouteRoute,
} as any)
const VerifyTokenRoute = VerifyTokenRouteImport.update({
  id: '/verify/$token',
  path: '/verify/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const IllustrationsIllustrationIdRouteRoute =
  IllustrationsIllustrationIdRouteRouteImport.update({
    id: '/$illustrationId',
    path: '/$illustrationId',
    getParentRoute: () => IllustrationsRouteRoute,
  } as any)
const IllustrationsNewIndexRoute = IllustrationsNewIndexRouteImport.update({
  id: '/new/',
  path: '/new/',
  getParentRoute: () => IllustrationsRouteRoute,
} as any)
const IllustrationsIllustrationIdIndexRoute =
  IllustrationsIllustrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IllustrationsIllustrationIdRouteRoute,
  } as any)
const IllustrationsIllustrationIdEditRoute =
  IllustrationsIllustrationIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => IllustrationsIllustrationIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/illustrations': typeof IllustrationsRouteRouteWithChildren
  '/illustrations/$illustrationId': typeof IllustrationsIllustrationIdRouteRouteWithChildren
  '/verify/$token': typeof VerifyTokenRoute
  '/illustrations/': typeof IllustrationsIndexRoute
  '/illustrations/$illustrationId/edit': typeof IllustrationsIllustrationIdEditRoute
  '/illustrations/$illustrationId/': typeof IllustrationsIllustrationIdIndexRoute
  '/illustrations/new/': typeof IllustrationsNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/illustrations': typeof IllustrationsIndexRoute
  '/illustrations/$illustrationId/edit': typeof IllustrationsIllustrationIdEditRoute
  '/illustrations/$illustrationId': typeof IllustrationsIllustrationIdIndexRoute
  '/illustrations/new': typeof IllustrationsNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/illustrations': typeof IllustrationsRouteRouteWithChildren
  '/illustrations/$illustrationId': typeof IllustrationsIllustrationIdRouteRouteWithChildren
  '/verify/$token': typeof VerifyTokenRoute
  '/illustrations/': typeof IllustrationsIndexRoute
  '/illustrations/$illustrationId/edit': typeof IllustrationsIllustrationIdEditRoute
  '/illustrations/$illustrationId/': typeof IllustrationsIllustrationIdIndexRoute
  '/illustrations/new/': typeof IllustrationsNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/illustrations'
    | '/illustrations/$illustrationId'
    | '/verify/$token'
    | '/illustrations/'
    | '/illustrations/$illustrationId/edit'
    | '/illustrations/$illustrationId/'
    | '/illustrations/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/verify/$token'
    | '/illustrations'
    | '/illustrations/$illustrationId/edit'
    | '/illustrations/$illustrationId'
    | '/illustrations/new'
  id:
    | '__root__'
    | '/'
    | '/illustrations'
    | '/illustrations/$illustrationId'
    | '/verify/$token'
    | '/illustrations/'
    | '/illustrations/$illustrationId/edit'
    | '/illustrations/$illustrationId/'
    | '/illustrations/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  IllustrationsRouteRoute: typeof IllustrationsRouteRouteWithChildren
  VerifyTokenRoute: typeof VerifyTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/illustrations': {
      id: '/illustrations'
      path: '/illustrations'
      fullPath: '/illustrations'
      preLoaderRoute: typeof IllustrationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/illustrations/': {
      id: '/illustrations/'
      path: '/'
      fullPath: '/illustrations/'
      preLoaderRoute: typeof IllustrationsIndexRouteImport
      parentRoute: typeof IllustrationsRouteRoute
    }
    '/verify/$token': {
      id: '/verify/$token'
      path: '/verify/$token'
      fullPath: '/verify/$token'
      preLoaderRoute: typeof VerifyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/illustrations/$illustrationId': {
      id: '/illustrations/$illustrationId'
      path: '/$illustrationId'
      fullPath: '/illustrations/$illustrationId'
      preLoaderRoute: typeof IllustrationsIllustrationIdRouteRouteImport
      parentRoute: typeof IllustrationsRouteRoute
    }
    '/illustrations/new/': {
      id: '/illustrations/new/'
      path: '/new'
      fullPath: '/illustrations/new/'
      preLoaderRoute: typeof IllustrationsNewIndexRouteImport
      parentRoute: typeof IllustrationsRouteRoute
    }
    '/illustrations/$illustrationId/': {
      id: '/illustrations/$illustrationId/'
      path: '/'
      fullPath: '/illustrations/$illustrationId/'
      preLoaderRoute: typeof IllustrationsIllustrationIdIndexRouteImport
      parentRoute: typeof IllustrationsIllustrationIdRouteRoute
    }
    '/illustrations/$illustrationId/edit': {
      id: '/illustrations/$illustrationId/edit'
      path: '/edit'
      fullPath: '/illustrations/$illustrationId/edit'
      preLoaderRoute: typeof IllustrationsIllustrationIdEditRouteImport
      parentRoute: typeof IllustrationsIllustrationIdRouteRoute
    }
  }
}

interface IllustrationsIllustrationIdRouteRouteChildren {
  IllustrationsIllustrationIdEditRoute: typeof IllustrationsIllustrationIdEditRoute
  IllustrationsIllustrationIdIndexRoute: typeof IllustrationsIllustrationIdIndexRoute
}

const IllustrationsIllustrationIdRouteRouteChildren: IllustrationsIllustrationIdRouteRouteChildren =
  {
    IllustrationsIllustrationIdEditRoute: IllustrationsIllustrationIdEditRoute,
    IllustrationsIllustrationIdIndexRoute:
      IllustrationsIllustrationIdIndexRoute,
  }

const IllustrationsIllustrationIdRouteRouteWithChildren =
  IllustrationsIllustrationIdRouteRoute._addFileChildren(
    IllustrationsIllustrationIdRouteRouteChildren,
  )

interface IllustrationsRouteRouteChildren {
  IllustrationsIllustrationIdRouteRoute: typeof IllustrationsIllustrationIdRouteRouteWithChildren
  IllustrationsIndexRoute: typeof IllustrationsIndexRoute
  IllustrationsNewIndexRoute: typeof IllustrationsNewIndexRoute
}

const IllustrationsRouteRouteChildren: IllustrationsRouteRouteChildren = {
  IllustrationsIllustrationIdRouteRoute:
    IllustrationsIllustrationIdRouteRouteWithChildren,
  IllustrationsIndexRoute: IllustrationsIndexRoute,
  IllustrationsNewIndexRoute: IllustrationsNewIndexRoute,
}

const IllustrationsRouteRouteWithChildren =
  IllustrationsRouteRoute._addFileChildren(IllustrationsRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  IllustrationsRouteRoute: IllustrationsRouteRouteWithChildren,
  VerifyTokenRoute: VerifyTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
